module.exports = __webpack_public_path__ + "static/media/FilterSmall.f877e576.svg";